import React, { memo } from 'react';
import Link from 'next/link';

import { usePagination } from '@mui/lab';

import { IPaginationProps } from './model';
import { List, ListItem } from './styles';

import { ChevronLeft, ChevronRight } from 'lucide-react';

export const Pagination = memo(
  ({
    pageQuantity,
    pageSelected = 1,
    routeHref,
    queryParams,
  }: IPaginationProps) => {
    const { items } = usePagination({
      count: pageQuantity,
      page: pageSelected,
    });

    const pageQueryParam = (page) => {
      if (!queryParams) return;

      return { ...queryParams, page: page };
    };

    const pathName = (page) => {
      if (queryParams) return `${routeHref}`;

      return `${routeHref}${page === 1 ? '' : `/page/${page}`}`;
    };

    return (
      <nav>
        <List>
          {items.map(({ page, type, selected, ...item }, index) => {
            if (item.disabled) return;
            let children = null;

            if (type === 'start-ellipsis' || type === 'end-ellipsis') {
              children = '…';
            } else if (type === 'page') {
              children = (
                <Link
                  href={{
                    pathname: pathName(page),
                    query: { ...pageQueryParam(page) },
                  }}
                  prefetch={false}
                  title={`Ir para à página ${page}`}
                >
                  {page}
                </Link>
              );
            } else {
              children = (
                <Link
                  href={{
                    pathname: pathName(page),
                    query: { ...pageQueryParam(page) },
                  }}
                  prefetch={false}
                  aria-label={
                    type === 'next' ? 'próxima página' : 'página anterior'
                  }
                >
                  {type === 'next' ? (
                    <ChevronRight size={16} />
                  ) : (
                    <ChevronLeft size={16} />
                  )}
                </Link>
              );
            }

            return (
              <ListItem key={`pagination-${index}`} selected={selected}>
                {children}
              </ListItem>
            );
          })}
        </List>
      </nav>
    );
  }
);
